export const SPORTS_PREFIX = {
    americanfootball: {
        name: 'American Football',
        code: 'AF',
    },
    athletics: {
        name: 'Athletics',
        code: 'AS',
    },
    australianrules: {
        name: 'Australian Rules',
        code: 'AR',
    },
    badminton: {
        name: 'Badminton',
        code: 'BM',
    },
    baseball: {
        name: 'Baseball',
        code: 'BE',
    },
    basketball: {
        name: 'Basketball',
        code: 'BB',
    },
    bowls: {
        name: 'Bowls',
        code: 'BL',
    },
    boxing: {
        name: 'Boxing',
        code: 'BO',
    },
    cricket: {
        name: 'Cricket',
        code: 'CR',
    },
    cycling: {
        name: 'Cycling',
        code: 'CY',
    },
    darts: {
        name: 'Darts',
        code: 'DA',
    },
    esports: {
        name: 'Esports',
        code: 'ES',
    },
    football: {
        name: 'Football',
        code: 'FB',
    },
    formulaone: {
        name: 'Formula One',
        code: 'F1',
    },
    gaelicfootball: {
        name: 'Gaelic Football',
        code: 'GF',
    },
    gaelichurling: {
        name: 'Gaelict Hurling',
        code: 'GH',
    },
    greyhoundracing: {
        name: 'Greyhounds',
        code: 'GR',
    },
    golf: {
        name: 'Golf',
        code: 'GF',
    },
    handball: {
        name: 'Handball',
        code: 'HB',
    },
    horseracing: {
        name: 'Horse Racing',
        code: 'HR',
    },
    icehockey: {
        name: 'Ice Hockey',
        code: 'IH',
    },
    internationalgreyhoundracing: {
        name: 'International Greyhoundracing',
        code: 'IG',
    },
    internationalhorseracing: {
        name: 'International Horse Racing',
        code: 'IN',
    },
    motorsport: {
        name: 'Motor Racing',
        code: 'MS',
    },
    mixedmartialarts: {
        name: 'Mixed Martial Arts',
        code: 'MI',
    },
    olympics: {
        name: 'Olympics',
        code: 'OL',
    },
    politics: {
        name: 'Politics',
        code: 'PT',
    },
    pool: {
        name: 'Pool',
        code: 'PL',
    },
    rugbyleague: {
        name: 'Rugby League',
        code: 'RL',
    },
    rugbyunion: {
        name: 'Rugby Union',
        code: 'RU',
    },
    snooker: {
        name: 'Snooker',
        code: 'SN',
    },
    tabletennis: {
        name: 'Table Tennis',
        code: 'TT',
    },
    tennis: {
        name: 'Tennis',
        code: 'TN',
    },
    tennisdoubles: {
        name: 'Tennis Doubles',
        code: 'TD',
    },
    tvspecials: {
        name: 'TV & Specials',
        code: 'TV',
    },
    volleyball: {
        name: 'Volleyball',
        code: 'VB',
    },
};

export const CUSTOM_PREFIX = {
    lottery: {
        name: 'Lottery',
        code: 'LO',
    },
    casino: {
        name: 'Casino',
        code: 'CS',
    },
    virtualsports: {
        name: 'Virtual Sports',
        code: 'VS',
    },
    livecasino: {
        name: 'Live Casino',
        code: 'LC',
    },
    horseracingantepost: {
        name: 'Horse racing ante post',
        code: 'HRAP',
    },
    bingo: {
        name: 'Bingo',
        code: 'BI',
    },
};
